/**
 * Get user full name
 * @returns {string}
 */
export function getCompanyId(store) {
  const { state } = store;
  return state.app.authenticatedUser.organisation.id;
}
